import { track, MLM } from '@sunrise/tracking'
import { MlmActionIds, buildMlmData } from '../../../utils/tracking/mlm'
import { AmsItem, AmsSearchResponse } from '../../../services/amsSearch/amsSearch.interface'
import { Ref, onMounted } from 'vue'
import { SlideDirection, useSliderDirection } from '../../../components/AmsSlider'
import baseTrackingData from './baseTrackingData'
import type AmsSlider from '../../../components/AmsSlider'

const trackMlmViewport = (item: AmsItem, page: number) => {
    MLM.trackView(buildMlmData([item], 'M_AMS_Slider', page, MlmActionIds.VIEWPORT, window.location.toString()))
}
const trackMlmView = (items: AmsItem[], page: number) => {
    MLM.trackView(buildMlmData(items, 'M_AMS_Slider', page, MlmActionIds.VIEW, window.location.toString()))
}
const trackMlmClick = (item: AmsItem, page: number) => {
    MLM.trackClick(buildMlmData([item], 'M_AMS_Slider', page, MlmActionIds.CLICK, window.location.toString()))
}

const trackTealiumClick = (item: AmsItem, elementPosition: number) => {
    track({
        ...baseTrackingData,
        mslayer_element_data_id: 'ed0000035',
        mslayer_element_text: item.title,
        mslayer_element_type_text: 'not_set',
        mslayer_element_position: elementPosition.toString(),
        mslayer_element_company_name: item.advertiser,
    })
}

const trackTealiumScroll = (position: string, direction: SlideDirection.Left | SlideDirection.Right) => {
    track({
        ...baseTrackingData,
        mslayer_element_data_id: 'ed0000034',
        mslayer_element_text: 'Auto_Slider',
        mslayer_element_type_text: { [SlideDirection.Right]: 'Rechts', [SlideDirection.Left]: 'Links' }[direction],
        mslayer_element_position: position,
        mslayer_element_company_name: 'not_set',
    })
}

export const useTracking = ({
    amsSearch,
    amsSliderRef,
}: {
    amsSearch: AmsSearchResponse
    amsSliderRef: Ref<InstanceType<typeof AmsSlider> | undefined>
}) => {
    const sliderDirection = useSliderDirection(amsSliderRef)

    const onAfterScroll = async () => {
        const intersection = await amsSliderRef.value?.calculateIntersection()
        if (!intersection) {
            throw new Error('M_AMS_Slider useTracking: no intersection')
        }
        const { elements, lastVisible } = intersection
        if (!lastVisible) {
            return
        }

        const direction = sliderDirection.getSlideDirection()

        if (direction === SlideDirection.NoChange) {
            return
        }

        const position = `${elements.indexOf(lastVisible) + 1}`
        trackTealiumScroll(position, direction)
    }

    const onItemClick = (item: AmsItem) => {
        trackMlmClick(item, amsSearch.page)
        trackTealiumClick(item, item.position)
    }

    onMounted(() => {
        trackMlmView(amsSearch.items, amsSearch.page)
    })

    const onItemInViewport = (item: AmsItem) => {
        trackMlmViewport(item, amsSearch.page)
    }

    return { onAfterScroll, onItemClick, onItemInViewport }
}
